
import { v4 as uuidv4, v4 } from 'uuid';
import { keyId, isMaintenanceIncluded, discountedPrice, positionNumber } from '../../lib/utils';

export const archiveNonConformityDoc = (nonConformity) =>( {
    _key: nonConformity?._key ? nonConformity?._key : uuidv4(),
    _id: nonConformity?._id ? nonConformity?._id : uuidv4(),
    nonConformity: nonConformity?.nonConformity,
    nNonConformities: nonConformity?.nNonConformities,
    image: nonConformity?.image,
    comments: nonConformity?.comments,
    createdOn: nonConformity?.createdOn,
    postedBy: nonConformity?.postedBy,
    assignedOn: nonConformity?.assignedOn,
    assigneBy: nonConformity?.assigneBy,
    completedBy: nonConformity?.completedBy,
    completedOn: nonConformity?.completedOn,
    _type:"deviceNonConformity",
    status: nonConformity?.status,
    archivedBy: nonConformity?.archivedBy, 
    archivedOn: nonConformity?.archivedOn,
})

export const deviceDoc = (device) => {
    return(
       {
            _key: nonConformity?._key ? nonConformity?._key : uuidv4(),
            _id: nonConformity?._id ? nonConformity?._id : uuidv4(),
           image: device?.image,
           label: device?.label,
           locations: device?.locations,
           templateDevice: device?.templateDevice,
           substituteDevice: device?.substituteDevice,
           substituteFields: device?.substituteFields,
           substituteReason: device?.substituteReason,
           fields: device?.fields,
           dates: device?.dates,
           userLog: device?.userLog,
           postedBy: device?.postedBy,
           comments: device?.comments,
           postedBy: device?.postedBy,
           createdOn: device?.createdOn,
           archivedBy: device?.archivedBy,
           archivedOn: device?.archivedOn,
           status: device?.status,
           nonConformities: device?.nonConformities,
           _type:"device", 
       }
    )
   }

   export const logDoc = (user, logType, historyDevice, position) => ({ 
    _type: "userLog",
    _key: keyId(), 
    _id: uuidv4(),     
    logType,
    date: Date.now(),
    postedBy:{
        _ref: user?._id,
        _type: "postedBy",
        _key: keyId()
    },
    latitude: position?.coords?.latitude,
    longitude: position?.coords?.longitude,
    historyDevice
        
})

export const deviceNonConformityDoc = (nonConformityId, user) => {
    const now = Date.now()
   return ({
        _id: uuidv4(),
        postedBy: [{ _type: 'postedBy', _ref: user._id,  _key: keyId(), }], 
        createdOn: now,
        status:"DA FARE",
        comments:[],
        nNonConformities:"1",
        _key: keyId(),
        _type: "deviceNonConformity",
        image:[],
        nonConformity:{
            _ref: nonConformityId,
            _type: "reference",
            _key: keyId(),
        }
    })
}

export const richEditorDoc = (text="") => {
    //const key = keyId()
    const doc = {
        blocks:[
            {
            data:{_key: keyId()},
            depth: 0,
            entityRanges: [],
            inlineStyleRanges : [],
            key: keyId(),
            _key: keyId(),
            text: text,
            type:"unstyled"
            }

        ],
        entityMap: {_key: keyId()},
        _key: keyId(),
        _id: uuidv4(),
        _type:"richTextObject"
    }
    return doc
}
/**
 * 
 * @param {*} blocks array of type richEditorListBlockDoc
 * @returns 
 */
export const richEditorDocAddBlocks = (blocks=[]) => {
    //const key = keyId()
    const doc = {
        blocks:[...blocks],
        entityMap: {_key: keyId()},
        _key: keyId(),
        _id: uuidv4(),
        _type:"richTextObject"
    }
    return doc
}
export const richEditorListBlockDoc = (text="") => {
    //const key = keyId()
    const doc = 
            {
            data:{_key: keyId()},
            depth: 0,
            entityRanges: [],
            inlineStyleRanges : [],
            key: keyId(),
            _key: keyId(),
            text: text,
            type:"unordered-list-item"
            }
    return doc
}



export const offerDocFromProductsAndList = (customerProduct, product, priceList, client) => ({
 
    customerProductId: customerProduct?._id?.toString(),
    label: customerProduct?.label?.toString(), 
    nonConformity: customerProduct?.nonConformity?.toString(), 
    hideNonConformityDescription: customerProduct?.hideNonConformityDescription?.toString(), 
    customerProduct: customerProduct?.label?.toString(), 
    pricelistCode: priceList?.priceListSource?.toString(), 
    law: customerProduct?.law?.richText,
    lawLabel: customerProduct?.law?.label,
    description: customerProduct?.details,
    descriptionText: customerProduct?.details?.blocks?.map?.((x)=>x?.text)?.toString(),
    unitPrice: isMaintenanceIncluded(client, customerProduct) ? 0 : priceList?.price?.toString(),
    supplierPrice: isMaintenanceIncluded(client, customerProduct) ? 0 : product?.price?.toString(),
    supplierProductId: product?._id,
    isSign: customerProduct?.isSign, 
    allowZero: isMaintenanceIncluded(client, customerProduct) ? 0 : customerProduct?.allowZero, 
    labourHours: customerProduct?.labourHours?.toString(),
    unit: customerProduct?.unit?.toString(),
    //manualQuantity: customerProduct?.manualQuantity?.toString(),
})
export const offerDocFromProduct = (customerProduct) => ({
 
    customerProductId: customerProduct?._id?.toString(),
    label: customerProduct?.label?.toString(), 
    nonConformity: customerProduct?.nonConformity?.toString(), 
    hideNonConformityDescription: customerProduct?.hideNonConformityDescription?.toString(), 
    customerProduct: customerProduct?.label?.toString(), 
    law: customerProduct?.law?.richText,
    lawLabel: customerProduct?.law?.label,
    description: customerProduct?.details,
    descriptionText: customerProduct?.details?.blocks?.map?.((x)=>x?.text)?.toString(),
    isSign: customerProduct?.isSign, 
    allowZero: customerProduct?.allowZero, 
    labourHours: customerProduct?.labourHours?.toString(),
    unit: customerProduct?.unit?.toString(),
    //manualQuantity: customerProduct?.manualQuantity?.toString(),
})

export const offerDocWithDescriptionText = (item) => {
    
    const allText = item?.description?.blocks?.map?.((x)=>x?.text).toString()
    const doc = {
        ...item,
        descriptionText: allText
    }
    return doc
}

export const generatedOfferWithTotalsDoc = (item={}) => {
    const {_id, _key, isManual, order, registerId,siteId, isSign, hide, allowZero, addedLocation, clientOrder, edited, nonConformity, deviceId, nonConformityId, registerTemplateId, customerProduct, customerProductId, pricelistCode, law, lawLabel, description, hideNonConformityDescription, location, quantity, unitPrice, supplierPrice, supplierProductId, discount, deviceFamilyId, offerPropertyId, offerPropertyLabel, offerProperty, deviceNonConformityId, labourHours, labourProduct, unit} = item
    //const discountedPrice = (price, discount) => price - (price * discount / 100 ).toFixed(2)
    const totalPrice = () => {
        if(unit) return Number(unitPrice) * 1?.toFixed(2).toString()
        if(labourProduct) return Number(unitPrice) * 1?.toFixed(2).toString()
        //if(manualQuantity) return (+unitPrice * +manualQuantity)?.toFixed(2).toString()
        return (Number(unitPrice) * Number(quantity))?.toFixed(2).toString()
    }
    const totalCost = () => {
        const labourHoursFormatted = labourHours ? Number(labourHours) : 1
        if(labourProduct) return  ((+supplierPrice * labourHoursFormatted)?.toFixed(2))
        if(unit) return supplierPrice && +supplierPrice*1?.toFixed(2).toString()
       // if(manualQuantity) return (+supplierPrice * +manualQuantity)?.toFixed(2).toString()
        return (+supplierPrice * Number(quantity))?.toFixed(2).toString()
    }
    const priceToClient = discountedPrice(Number(totalPrice()), Number(discount))?.toFixed(2)?.toString()
    const profit = (Number(priceToClient) - Number(totalCost())).toFixed(2)?.toString()
    const margin = ((Number(profit)/Number(totalPrice())) * 100).toFixed(2)?.toString()
    const unitProfit = (discountedPrice(+unitPrice, +discount) - +supplierPrice).toFixed(2)?.toString()
    const discountedUnitPrice = discountedPrice(Number(unitPrice), Number(discount)).toFixed(2)?.toString()

    const doc = {
        _id,
        _key,
        registerId,
        siteId,
        nonConformity,
        hide,
        nonConformityId,
        registerTemplateId,
        customerProduct,
        customerProductId,
        pricelistCode,
        law,
        lawLabel,
        addedLocation, 
        clientOrder,
        edited,
        description,
        descriptionText: description?.blocks?.map?.((x)=>x?.text)?.toString(),
        hideNonConformityDescription,
        location,
        isManual,
        quantity: quantity*1.00?.toFixed(2).toString(),
        unitPrice: +unitPrice*1.00?.toFixed(2).toString(),
        discountedUnitPrice: discountedUnitPrice * 1.00?.toFixed(2).toString(),
        priceToClient:+priceToClient*1.00?.toFixed(2).toString(),
        discount:+discount*1.00?.toFixed(2).toString(),
        supplierPrice: +supplierPrice*1.00?.toFixed(2).toString(),
        supplierProductId: supplierProductId,
        totalCost: +totalCost()*1.00?.toFixed(2).toString(),
        margin: !Number(margin) ? 0 : +margin*1.00?.toFixed(2).toString(),
        profit:+profit*1.00?.toFixed(2).toString(),
        unitProfit:+unitProfit*1.00?.toFixed(2).toString(),
        order,
        offerPropertyId,
        offerPropertyLabel,
        deviceFamilyId,
        deviceId,
        deviceNonConformityId, 
        allowZero,
        isSign,
        labourHours,
        labourProduct,

        unit
    }
    //if(isManual)console.log("ALL REG OFFER", doc)
                    
    return doc
}

export const generatedOfferDoc = (offerField) => ({
    _id: offerField?._id ? offerField?._id : uuidv4(),
    customerProductId: offerField?.customerProductId?.toString(),
    registerId: offerField?.registerId?.toString(),
    siteId: offerField?.siteId?.toString(),
    nonConformity: offerField?.nonConformity?.toString(), 
    hideNonConformityDescription: offerField?.hideNonConformityDescription?.toString(), 
    offerPropertyId: offerField?.offerPropertyId?.toString(), 
    offerPropertyLabel: offerField?.offerPropertyLabel?.toString(), 
    nonConformityId: offerField?.nonConformityId?.toString(),
    registerTemplateId: offerField?.registerTemplateId?.toString(),
    customerProduct: offerField?.customerProduct?.toString(), 
    pricelistCode: offerField?.pricelistCode?.toString(), 
    law: offerField?.law,
    lawLabel: offerField?.lawLabel,
    addedLocation: offerField?.addedLocation, 
    clientOrder: offerField?.clientOrder,
    edited: offerField?.edited,
    deviceId: offerField?.deviceId?.toString(),
    description: offerField?.description,
    descriptionText: offerField?.description?.blocks?.map?.((x)=>x?.text)?.toString(),
    location: offerField?.location?.toString(), 
    quantity: offerField?.quantity?.toString(), 
    unitPrice: offerField?.unitPrice?.toString(),
    supplierPrice: offerField?.supplierPrice?.toString(),
    supplierProductId: offerField?.supplierProductId?.toString(),
    discount: offerField?.discount?.toString(),
    deviceFamilyId: offerField?.deviceFamilyId?.toString(), 
    deviceNonConformityId: offerField?.deviceNonConformityId?.toString(),
    order: offerField?.order?.toString(),
    _key: offerField?._key ? offerField?._key : keyId(),
    isSign: offerField?.isSign, 
    allowZero: offerField?.allowZero, 
    labourHours: offerField?.labourHours?.toString(),
    labourProduct: offerField?.labourProduct,
    hide: offerField?.hide,
    unit: offerField?.unit?.toString(),
    //manualQuantity: offerField?.manualQuantity?.toString(),
    isManual:offerField?.isManual,

})


export const referenceDoc = (id, key) => {
    if(id) return {_ref: id, _type:"reference", _key: key ? key : keyId()}
    return undefined
  }

  export const deviceExpandedDoc = (device, deviceNonConformity) => {
    const quantity = () => {
        if(!deviceNonConformity?.nNonConformities) return 1
        return + deviceNonConformity?.nNonConformities
    }
    const doc = {
        ...device, 
        positionNumber: positionNumber(device), 
        templateDeviceId: device?.templateDevice?._ref,
        nNonConformities: quantity()

     }
     return doc
}